<style lang="less">
    @import "./messageManage.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
                            <Form-item label="消息标题" prop="title">
                                <Input type="text" v-model="searchForm.title" placeholder="请输入消息标题" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="消息内容" prop="content">
                                <Input type="text" v-model="searchForm.content" placeholder="请输入消息内容" clearable style="width: 200px"/>
                            </Form-item>
                            <span v-if="drop">
                                <!--<Form-item label="消息类型" prop="type">
                                  <Select v-model="searchForm.type" placeholder="请选择消息类型" clearable style="width: 200px">
                                    <Option v-for="(item, i) in dictMessageType" :key="i" :value="item.value">{{item.title}}</Option>
                                  </Select>
                                </Form-item>-->
                                <Form-item label="创建时间">
                                  <DatePicker v-model="selectDate" type="daterange" split-panels format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                                </Form-item>
                             </span>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">发送消息</Button>
                        <Button @click="delAll" icon="md-trash">批量删除</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal :title="modalTitle" v-model="sendModalVisible" :mask-closable="false" :width="600" :styles="{top: '30px'}">
            <Form ref="searchForm" :model="searchForm" :label-width="70" >
                <FormItem label="推送类型" >
                    <RadioGroup v-model="searchForm.sendType" @on-change="pushMsg">
                        <Radio :label="0">全体</Radio>
                        <Radio :label="1">企业学员</Radio>
                        <Radio :label="2">平台学员</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="选择员工" prop="userIds" v-show="staffType">
                    <user-choose buttonText="选择员工" :userType="userType" @on-change="handleSelectUser" ref="user"></user-choose>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="sendModalVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handelSubmitMsg">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {addMessage, deleteMessage, editMessage, getDictDataByType, getMessageData,sendMsg} from "@/api/index";
    import circleLoading from "../../my-components/circle-loading.vue";
    import userChoose from "../../my-components/flyme/user-choose";

    export default {
        name: "message-manage",
        components: {
            circleLoading,
            userChoose
        },
        data() {
            return {
                loading: true, // 表单加载状态
                userLoading: true,
                //tableHeigh: '450px',
                operationLoading: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                selectUsers: [],
                drop: false,
                submitLoading: false,
                userType: "UT_STUDENT",
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                modalTitle: "发送消息",
                sendModalVisible: false,
                staffType: false,
                searchForm: {
                    id: "",
                    // 搜索框对应data对象
                    title: "",
                    content: "",
                    userIds: [],
                    sendType: 0,
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    startDate: "", // 起始时间
                    endDate: "" // 终止时间
                },
                selectDate: null, // 选择日期绑定modal
                columns: [
                    // 表头
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        type: "index",
                        title: "序号",
                        width:70,
                        align: "center"
                    },
                    {
                        title: "消息标题",
                        key: "messageTitle",
                        width: 200,
                        ellipsis:true,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title: "消息摘要",
                        key: "summary",
                        width: 200,
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: "类型",
                        key: "messageTypeTitle",
                        width: 120,
                        align: "center"
                    },
                    {
                        title: "发送状态",
                        key: "sendStatus",
                        width: 120,
                        align: "center",
                        render: (h, params) => {
                            let re = "";
                            if (params.row.sendStatus == 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "purple"
                                            }
                                        },
                                        "未发送"
                                    )
                                ]);
                            } else if (params.row.sendStatus == 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "已发送"
                                    )
                                ]);
                            }
                        }
                    },
                    {
                        title: "发送范围",
                        key: "sendType",
                        width: 120,
                        align: "center",
                        render: (h, params) => {
                            let re = "";
                            if (params.row.sendType === 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "purple"
                                            }
                                        },
                                        "所有用户"
                                    )
                                ]);
                            } else if (params.row.sendType == 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "企业用户"
                                    )
                                ]);
                            } else if (params.row.sendType == 2) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "指定用户"
                                    )
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "red"
                                            }
                                        },
                                        "未发送"
                                    )
                                ]);
                            }
                        }
                    },
                    /*{
                        title: "新创建账号推送",
                        key: "createSend",
                        align: "center",
                        width: 135,
                        render: (h, params) => {
                            if (params.row.createSend) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "开启"
                                    )
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "default"
                                            }
                                        },
                                        "关闭"
                                    )
                                ]);
                            }
                        }
                    },*/
                    {
                        title: "创建时间",
                        key: "createTime",
                        width: 180,
                        sortable: true,
                        sortType: "desc"
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 280,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                               h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.sendMsg(params.row);
                                            }
                                        }
                                    },
                                    "发送"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ],
                data: [], // 表单数据
                total: 0, // 表单数据总数
                dictMessageType: []
            };
        },
        methods: {
            init() {
                this.getDataList();
                this.getDictMessageType();
            },
            getDictMessageType() {
                getDictDataByType("messageType").then(res => {
                    if (res.status) {
                        this.dictMessageType = res.data;
                    }
                });
            },
            pushMsg() {
                this.searchForm.userIds = [];
                this.$refs.user.getUserChosed();
                if(this.searchForm.sendType == 0){//全体
                    this.staffType = false;
                }
                if(this.searchForm.sendType == 1){//企业
                    this.staffType = false;
                }
                if(this.searchForm.sendType == 2){//指定员工
                    this.staffType = true;
                }
            },
            handleSelectUser(v) {
                if (v.length > 0) {
                    this.searchForm.userIds = v[0].id;
                    this.selectUsers = v;
                } else {
                    this.searchForm.userIds = [];
                    this.selectUsers = v;
                }

            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            getDataList() {
                this.loading = true;
                getMessageData(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            handelSubmitMsg(v){
                this.submitLoading = true;
                //选择推送员工时进行赋值
                let ids = [];
                this.selectUsers.forEach(e => {
                    ids.push(e.id);
                });
                this.searchForm.userIds = ids;
                sendMsg(this.searchForm).then(res => {
                    this.submitLoading = false;
                    if (res.status === true) {
                        this.$Message.success("操作成功");
                        this.getDataList();
                        this.sendModalVisible = false;
                    }
                });
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            add() {
                let query = {type: 0, backRoute: this.$route.name};
                this.$router.push({
                    name: "add_edit_message",
                    query: query
                });
            },
            edit(v) {
                let query = {type: 1, id: v.id, backRoute: this.$route.name};
                this.$router.push({
                    name: "add_edit_message",
                    query: query
                });
            },
            sendDetail(v) {
                let query = {id: v.id};
                this.$router.push({
                    name: "message_send_detail",
                    query: query
                });
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    // 记得确认修改此处
                    content: "您确认要删除?",
                    onOk: () => {
                        // 删除
                        this.operationLoading = true;
                        deleteMessage(v.id).then(res => {
                            this.operationLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.getDataList();
                            }
                        });
                    }
                });
            },
            sendMsg(v){
                if(v.sendStatus == 1){
                    this.$Message.error("该消息已经发送，不能重复发送");
                    return;
                }
                this.searchForm.id = v.id;
                this.sendModalVisible = true;
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            delAll() {
                if (this.selectCount <= 0) {
                    this.$Message.warning("您还未选择要删除的数据");
                    return;
                }
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
                    onOk: () => {
                        let ids = "";
                        this.selectList.forEach(function (e) {
                            ids += e.id + ",";
                        });
                        ids = ids.substring(0, ids.length - 1);
                        // 批量删除
                        this.operationLoading = true;
                        deleteMessage(ids).then(res => {
                            this.operationLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.clearSelectAll();
                                this.getDataList();
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            this.init();
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop;
        },watch: {
            // 监听路由变化
            $route(to, from) {
                this.getDataList();
            }
        }
    };
</script>